// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-sheet--offset {\n    top: -24px;\n    position: relative;\n    z-index: 2;\n}\n.homeGraf {\n    min-height: 100px;\n    font-size: 1.3rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
